import { Button, type ButtonProps } from "@repo/ui";
import { cn } from "@repo/utils";

type Props = {
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
} & ButtonProps;

const BigButton = ({ children, icon, iconPosition, className, ...props }: Props) => {
  return (
    <Button
      className={cn(
        "flex max-w-2xs items-center justify-around gap-10 px-9 py-8 text-2xl font-semibold max-md:py-4 max-md:text-xl",
        className
      )}
      icon={icon}
      iconPosition={iconPosition}
      size={"pill"}
      {...props}
    >
      {children}
    </Button>
  );
};

export default BigButton;
